<template>
    <div class="row">
        <div class="col-md-6">
            <div class="admin-form theme-primary tab-pane mw700 active" role="tabpanel">
                <div class="panel panel-primary heading-border">
                    <div class="panel-heading">
                        <span class="panel-title">
                            <i class="fa fa-pencil-square"></i>
                            <span v-if="company.id">Редактирование компании</span>
                            <span v-else>Добавление компании</span>
                        </span>
                    </div>
                    <form @submit.prevent="submit">
                        <div class="panel-body p25">
                            <div class=" section row">

                                <div class="col-md-6">
                                    <label class="switch switch-primary">
                                        <input type="checkbox" id="form-company-status" v-model="$v.company.status.$model" value="1">
                                        <label for="form-company-status" data-on="Да" data-off="Нет"></label>
                                        <span>Активный</span>
                                    </label>
                                </div>

                            </div>

                            <div class="section row">
                                <div class="col-md-12">
                                    <label class="field-label">Наименование</label>
                                    <label class="field prepend-icon">
                                        <input type="text" v-model="$v.company.name.$model" class="gui-input"
                                               autocomplete="off">
                                        <label class="field-icon"><i class="fa fa-tag"></i></label>
                                    </label>
                                    <div v-if="$v.company.name.$error === true || forms.company.errors.name" class="error">
                                        {{ this.forms.company.errors.name ? this.forms.company.errors.name.join(', ') : 'Введите верное значение' }}
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="panel-footer">
                            <button type="submit" class="button btn-primary" :disabled="forms.company.isSubmitting">
                                <span v-if="company.id">Сохранить</span>
                                <span v-else>Добавить</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-md-6" v-if="company.id">
            <div class="panel ">
                <div class="panel-heading">
                    <span class="panel-title">Логотип</span>
                    <span class="panel-controls"></span>
                </div>
                <form>
                    <div class="panel-body" v-if="company.image.image">
                        <div class="col-md-6">
                            <img :src="company.image.image">
                        </div>
                    </div>
                    <div class="panel-menu">
                        <div v-if="Object.keys(forms.avatar.errors).length > 0" class="error pb10">
                            {{ this.forms.avatar.errors.image.join(', ') }}
                        </div>
                        <label class="btn btn-primary mr10" :disabled="forms.avatar.isSubmitting">
                            <input type="file" class="hidden" v-on:change="selectImage">
                            <span class="glyphicon glyphicon-upload"></span>
                            Загрузить
                        </label>
                    </div>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
    import Company from "../../models/Company";
    import { required } from 'vuelidate/lib/validators';
    import { validationMixin } from 'vuelidate';
    import ValidationError from "../../classes/ValidationError";

    export default {
        mixins: [validationMixin],
        async beforeRouteEnter(to, from, next) {
            if (to.params.id) {
                try {
                    const company = await Company.get(to.params.id);
                    next(component => {
                        component.company = company;
                    });
                } catch (error) {
                    next({
                        name: 'error',
                        path: to.fullPath,
                        params: {
                            code: error.response.status,
                            codeText: error.response.statusText,
                            message: error.response.data.message,
                            trace: error.response.data.type,
                        },
                    })
                }
            } else {
                next(component => {
                    Object.assign(component.$data, component.$options.data.apply(component));
                });
            }
        },
        data() {
            return {
                company: new Company({
                    name: '',
                    status: Company.STATUS_ACTIVE,
                }),
                forms: {
                    company: {
                        isSubmitting: false,
                        errors: {},
                    },
                    avatar: {
                        isSubmitting: false,
                        upload: null,
                        errors: {},
                    },
                },
            };
        },
        validations: {
            company: {
                name: {required},
                status: {},
            },
        },
        methods: {
            async selectImage(event) {
                this.forms.avatar.isSubmitting = true;
                const image = event.target.files[0];
                this.forms.avatar.errors = {};

                try {
                    await this.company.updateImage(image);
                } catch (error) {
                    if (error instanceof ValidationError) {
                        this.forms.avatar.errors = error.errors;
                    } else {
                        this.$notify({
                            type: 'error',
                            text: 'Ошибка загрузки логотипа'
                        });
                    }
                }

                this.forms.avatar.isSubmitting = false;
            },
            async submit() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }

                this.forms.company.isSubmitting = true;
                this.forms.company.errors = {};

                if (this.company.id) {

                    try {
                        await this.company.update();
                    } catch (error) {
                        this.forms.company.errors = error.errors;
                    }

                } else {

                    try {
                        const newCompany = await Company.add(this.company.name, this.company.status);
                        this.company = newCompany;
                        await this.$router.push({name: 'companies-edit', params: {id: newCompany.id}});
                    } catch (error) {
                        this.forms.company.errors = error.errors;
                    }

                }

                this.forms.company.isSubmitting = false;
            },
        },
        metaInfo() {
            return {
                title: 'Компании - ' + (this.company.id ? 'редактирование' : 'добавление'),
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>